import { verify } from 'paseto-ts/v4';

const publicKey = import.meta.env.VITE_APP_PUBLIC_KEY

export const decrypt = async (token: string) => {
  try {
    const { payload } = await verify(
      publicKey,
      token,
    );

    return payload;
  } catch (error) {
    console.error('Decryption failed:', error);
  }
}